import Stack from '@mui/material/Stack';
import ButtonBase from '@mui/material/ButtonBase';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

import { ISocialProofApiPost } from '../../../api/social-proof-api';

const SLIDE_WIDTH_SM = 200;
const SLIDE_WIDTH_MD = 389;

interface ISocialProofSlideProps {
    post: ISocialProofApiPost;
}

export const SocialProofSlide = ({ post }: ISocialProofSlideProps) => {
    const handleOpen = () => {
        const taggingPayload = {
            event: 'ctaClick',
            linkDetails: {
                name: 'IG Social Proof Open Dialogue',
                position: 'instagram posts carousel',
            },
        };
        window?.adobeDataLayer?.push(taggingPayload);
    };

    return (
        <>
            <Stack
                direction="column"
                sx={{
                    width: { xs: SLIDE_WIDTH_SM, md: SLIDE_WIDTH_MD },
                }}
            >
                <ButtonBase
                    onClick={handleOpen}
                    sx={({ palette }) => ({
                        width: '100%',
                        height: { xs: SLIDE_WIDTH_SM, md: SLIDE_WIDTH_MD },
                        borderRadius: { xs: 1.5 },
                        ':focus': {
                            outline: '2px solid',
                            outlineColor: palette.primary.main,
                        },
                    })}
                >
                    <Paper
                        elevation={0}
                        sx={{
                            height: { xs: SLIDE_WIDTH_SM, md: SLIDE_WIDTH_MD },
                            width: '100%',
                            ':hover': {
                                boxShadow: 2,
                            },
                            borderRadius: 1.5,
                            overflow: 'hidden',
                        }}
                    >
                        <Box
                            sx={{
                                position: 'relative',
                                height: '100%',
                                iframe: {
                                    border: '1px solid #CCD0D6 !important',
                                    borderRadius: '24px !important',
                                    height: '100% !important',
                                    width: '100% !important',
                                    maxWidth: 'none !important',
                                },
                                '::after': {
                                    content: '" "',
                                    display: 'block',
                                    position: 'absolute',
                                    left: '2.15rem',
                                    bottom: 0,
                                    right: '2.15rem',
                                    top: '3.15rem',
                                },
                            }}
                            dangerouslySetInnerHTML={{ __html: post.html }}
                        />
                    </Paper>
                </ButtonBase>
            </Stack>
        </>
    );
};
